export class TagEntry {
    timestamp: any;

    constructor(timestamp: any, public value: number, parse?: boolean) {
        if (parse === false) {
            this.timestamp = timestamp;
        } else {
            this.timestamp = Date.parse(timestamp);
        }
      
    }
}


// WEBPACK FOOTER //
// ./src/models/trend-live-models/TagEntry.ts